import BaseModel from "model/BaseModel"


export default class Order extends BaseModel{

    constructor(data) {
        super(data, "/api/orders")
    }
}
